import { server } from "@/api";

const prefix = 'api/messaging'

export const conversations = {
    // Get user's conversations by type
    // params: { type: 'direct|session|company', per_page: 20 }
    // Returns conversations ordered by newest activity first (updated_at desc)
    paginate: async (data = {}) => {
        return await server().get(prefix + '/conversations', { params: data })
    },

    // Get direct conversation with specific user
    // params: { user_id }
    getDirect: async (userId) => {
        return await server().get(prefix + '/conversations/direct/' + userId)
    },

    // Get session conversation
    // params: { session_id }
    getSession: async (sessionId) => {
        return await server().get(prefix + '/conversations/session/' + sessionId)
    },

    // Get company conversation
    // params: { company_id }
    getCompany: async (companyId) => {
        return await server().get(prefix + '/conversations/company/' + companyId)
    },

    // Get conversation messages
    // params: { per_page: 50 }
    // conversationId: UUID string
    getMessages: async (conversationId, data = {}) => {
        return await server().get(prefix + '/conversations/' + conversationId + '/messages', { params: data })
    },

    // Mark conversation as read
    // conversationId: UUID string
    markAsRead: async (conversationId) => {
        return await server().post(prefix + '/conversations/' + conversationId + '/read')
    },

    // Get conversation participants
    // conversationId: UUID string
    getParticipants: async (conversationId) => {
        return await server().get(prefix + '/conversations/' + conversationId + '/participants')
    }
}

export const messages = {
    // Send text message
    // data: { content: string }
    // conversationId: UUID string
    sendText: async (conversationId, data) => {
        return await server().post(prefix + '/conversations/' + conversationId + '/messages/text', data)
    },

    // Send file message
    // data: { file: File, content?: string }
    // conversationId: UUID string
    sendFile: async (conversationId, data) => {
        const formData = new FormData()
        formData.append('file', data.file)
        if (data.content) {
            formData.append('content', data.content)
        }
        return await server().post(prefix + '/conversations/' + conversationId + '/messages/file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    },

    // Send missed call message
    // data: { metadata?: { call_type: 'video|voice', duration: number, reason: string } }
    // conversationId: UUID string
    sendMissedCall: async (conversationId, data = {}) => {
        return await server().post(prefix + '/conversations/' + conversationId + '/messages/missed-call', data)
    },

    // Send video call request
    // data: { metadata?: { request_id: string, expires_at: string } }
    // conversationId: UUID string
    sendVideoCallRequest: async (conversationId, data = {}) => {
        return await server().post(prefix + '/conversations/' + conversationId + '/messages/video-call-request', data)
    },

    // Send voice call request
    // data: { metadata?: { request_id: string, expires_at: string } }
    // conversationId: UUID string
    sendVoiceCallRequest: async (conversationId, data = {}) => {
        return await server().post(prefix + '/conversations/' + conversationId + '/messages/voice-call-request', data)
    },

    // Send call ended message
    // data: { metadata?: { call_type: 'video|voice', duration: number, reason: string } }
    // conversationId: UUID string
    sendCallEnded: async (conversationId, data = {}) => {
        return await server().post(prefix + '/conversations/' + conversationId + '/messages/call-ended', data)
    },

    // Send call rejected message
    // data: { metadata?: { call_type: 'video|voice', reason: string } }
    // conversationId: UUID string
    sendCallRejected: async (conversationId, data = {}) => {
        return await server().post(prefix + '/conversations/' + conversationId + '/messages/call-rejected', data)
    },

    // Send call accepted message
    // data: { metadata?: { call_type: 'video|voice', call_id: string } }
    // conversationId: UUID string
    sendCallAccepted: async (conversationId, data = {}) => {
        return await server().post(prefix + '/conversations/' + conversationId + '/messages/call-accepted', data)
    },

    // Delete message (only sender can delete)
    // messageId: UUID string
    delete: async (messageId) => {
        return await server().delete(prefix + '/messages/' + messageId)
    },

    // Get unread count for conversation
    // conversationId: UUID string
    getUnreadCount: async (conversationId) => {
        return await server().get(prefix + '/conversations/' + conversationId + '/unread-count')
    }
}

const messagingApi = { conversations, messages }
export default messagingApi;